import React from 'react'
import Gamepad from 'react-gamepad'

var A_pressed = false
var B_pressed = false
var X_pressed = false
var Y_pressed = false
var holdClick = false

const GamepadReact = (props) => {
  const onAxisChangeHandler = (axisName, value, previousValue) => {
    if (axisName == 'LeftStickX') {
      if (value == -1) {
        // onLeftHandler();
        props.GamepadPressed('left')
      }
      if (value == 1) {
        // onRightHandler();
        props.GamepadPressed('right')
      }
      if (value == 0) {
      }
    }
    if (axisName == 'LeftStickY') {
      if (value == -1) {
        //  onDownHandler();
        props.GamepadPressed('down')
      }
      if (value == 1) {
        //   onUpHandler();
        props.GamepadPressed('up')
      }
      if (value == 0) {
        holdClick = false
      }
    }
    if (axisName == 'RightStickX') {
      if (value == -1) {
        // onLeftHandler();
        props.GamepadPressed('left')
      }
      if (value == 1) {
        // onRightHandler();
        props.GamepadPressed('right')
      }
      if (value == 0) {
      }
    }
    if (axisName == 'RightStickY') {
      if (value == -1) {
        //  onDownHandler();
        props.GamepadPressed('down')
      }
      if (value == 1) {
        //   onUpHandler();
        props.GamepadPressed('up')
      }
      if (value == 0) {
        holdClick = false
      }
    }
    console.log(axisName, value)
  }

  const onButtonChangeHandler = (buttonName, pressed) => {
    if (buttonName == 'A') {
      if (pressed) {
        A_pressed = true
        onA()
      } else {
        A_pressed = false
      }
    }
    if (buttonName == 'B') {
      if (pressed) {
        B_pressed = true
        onB()
      } else {
        B_pressed = false
      }
    }
    if (buttonName == 'X') {
      if (pressed) {
        X_pressed = true
        onX()
      } else {
        X_pressed = false
      }
    }
    if (buttonName == 'Y') {
      if (pressed) {
        Y_pressed = true
        onY()
      } else {
        Y_pressed = false
      }
    }
    if (buttonName == 'LB') {
      if (pressed) {
        props.GamepadPressed('L')
      } else {
      }
    }
    if (buttonName == 'RB') {
      if (pressed) {
        props.GamepadPressed('R')
      } else {
      }
    }
    if (buttonName == 'Start') {
      if (pressed) {
        props.GamepadPressed('Start')
      } else {
      }
    }
    if (buttonName == 'Back') {
      if (pressed) {
        props.GamepadPressed('Select')
      } else {
      }
    }
  }

  const onA = () => {
    props.GamepadPressed('A')
    CheckAB_Pressed()
  }
  const onB = () => {
    props.GamepadPressed('B')
    CheckAB_Pressed()
  }

  const CheckAB_Pressed = () => {
    if (A_pressed && B_pressed) {
    }
  }
  const onX = () => {
    props.GamepadPressed('X')
  }
  const onY = () => {
    props.GamepadPressed('Y')
  }

  const connectHandler = (gamepadIndex) => {
    // console.log(`Gamepad ${gamepadIndex} connected !`);
  }
  return (
    <div>
      <Gamepad
        gamepadIndex={0}
        onAxisChange={onAxisChangeHandler}
        onConnect={connectHandler}
        onButtonChange={onButtonChangeHandler}
      >
        <span></span>
      </Gamepad>
      <Gamepad
        gamepadIndex={1}
        onAxisChange={onAxisChangeHandler}
        onConnect={connectHandler}
        onButtonChange={onButtonChangeHandler}
      >
        <span></span>
      </Gamepad>
    </div>
  )
}
export default GamepadReact
